import { capitalize } from "lodash";

export const SALON_CAMA = "salon cama";
export const SEMI_CAMA = "semi cama";
export const PREMIUM = "premium";

export const getNormalizedClassName = (raw_class_name: string) => {
  const salon_cama_regex = /sal(?:ón|on).*cama/gi;
  const semi_cama_regex = /semi.*cama/gi;
  const premium_regex = /premium/gi;

  if (salon_cama_regex.test(raw_class_name)) {
    return SALON_CAMA;
  } else if (semi_cama_regex.test(raw_class_name)) {
    return SEMI_CAMA;
  } else if (premium_regex.test(raw_class_name)) {
    return PREMIUM;
  }

  return raw_class_name;
};

export function getNormalizedClassNameCapitalized(raw_class_name: string) {
  return capitalize(getNormalizedClassName(raw_class_name));
}
